import * as React from 'react';

import { Button, ErrorBox, Form, Input, SaveStatus, Wrapper } from 'common/components';
import { Section } from 'templates/core';

import { useAdminSet } from '../../queries';
import Heading from '../Heading';
import Strong from '../Strong';
import { fields, SetAdminFields, validationSchema } from './consts';

const SetAdmin = () => {
  const { mutate: setAdmin, isLoading, isError, isSuccess, error } = useAdminSet();
  const saveStatus = { isLoading, isError, isSuccess };

  const handleSubmit = (values: SetAdminFields) => {
    const payload = {
      email: values.email,
    };
    setAdmin(payload);
  };
  return (
    <Form onSubmit={handleSubmit} validationSchema={validationSchema}>
      <Heading>
        Set admin
        <SaveStatus {...saveStatus} />
      </Heading>
      <p>
        If you want to grant admin privileges, please provide an <Strong>existing</Strong>{' '}
        user&apos;s e-mail address and click the button.
      </p>
      <Input name={fields.email.name} label={fields.email.label} />
      {error && (
        <Section>
          <ErrorBox error={error} />
        </Section>
      )}
      <Wrapper margin={[2, 0]}>
        <Button type="submit" isLoading={isLoading}>
          Set admin
        </Button>
      </Wrapper>
    </Form>
  );
};

export default SetAdmin;
